import { takeEvery, put, call } from 'redux-saga/effects';
import {
    Actions,
    unassignBuildingUserSuccess, unassignBuildingUserFailure,
} from 'actions/buildingUserActions';
import { apiDelete } from './apiSagas';
import { toError } from 'shared/util/toError';



export function* unassignBuildingUserRequestWatcher() {
    yield takeEvery(Actions.UNASSIGN_BUILDING_FROM_USER_REQUEST, unassignBuildingUserSaga);
}

function* unassignBuildingUserSaga(action: any) {
    const { buildingId, userId } = action.payload;

    try {
        yield call(apiDelete, `/api/buildings/${buildingId}/users/${userId}`);
        yield put(unassignBuildingUserSuccess({ buildingId, userId }));
    }
    catch (e) {
        const err = toError(e);
        yield put(unassignBuildingUserFailure(err, { buildingId, userId }));
    }
}
